import { render, staticRenderFns } from "./UcContractInvoicing.yaml?vue&type=template&id=0851b3fc&component"
import script from "./UcContractInvoicing.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractInvoicing.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports